import customSqlSource from 'data/sources/common/customSqlSource';
import { CUSTOMSQL_LAYER_ID } from 'components/layers/common/CustomSqlLayer';

import customSqlSecondarySource from 'data/sources/common/customSqlSecondary';
import { CUSTOMSQL_SECONDARY_LAYER_ID } from 'components/layers/common/CustomSqlSecondaryLayer';

import customSqlThirdSource from 'data/sources/common/customSqlThird';
import { CUSTOMSQL_THIRD_LAYER_ID } from 'components/layers/common/CustomSqlThirdLayer';

import customSqlFourthSource from 'data/sources/common/customSqlFourth';
import { CUSTOMSQL_FOURTH_LAYER_ID } from 'components/layers/common/CustomSqlForthLayer';

import customSqlFifthSource from 'data/sources/common/customSqlFifth';
import { CUSTOMSQL_FIFTH_LAYER_ID } from 'components/layers/common/CustomSqlFifthLayer';

import { HISTORICALHCCLINTERSECTION_LAYER_ID } from 'components/layers/infrastructure/HistoricalHCCLIntersectionLayer';
import historicalHCCLIntersectionSource from 'data/sources/infrastructure/historicalHCCLIntersectionSource';

import { POINTOFINTEREST_LAYER_ID } from 'components/layers/infrastructure/PointOfInterestLayer';
import pointOfInterestSource from 'data/sources/infrastructure/pointOfInterestSource';

import { HISTORICALHCCL_LAYER_ID } from 'components/layers/infrastructure/HistoricalHCCLLayer';
import historicalHCCLSource from 'data/sources/infrastructure/historicalHCCLSource';

import { CALEQUITYINDEX_LAYER_ID } from 'components/layers/infrastructure/CalEquityIndexLayer';
import calEquityIndexSource from 'data/sources/infrastructure/calEquityIndexSource';

import { TRANSIT_ROUTE_LAYER_ID } from 'components/layers/infrastructure/TransitRouteLayer';
import transitRouteSource from 'data/sources/infrastructure/transitRouteSource';

import { TRANSIT_STOP_LAYER_ID } from 'components/layers/infrastructure/TransitStopLayer';
import transitStopSource from 'data/sources/infrastructure/transitStopSource';

import { HISTORICALHIGHCOLLISIONVIEW_LAYER_ID } from 'components/layers/environment/HistoricalHighCollisionLayer';
import historicalHighCollisionSource from 'data/sources/environment/historicalHighCollisionSource';

import { HISTORICALHIGHCOLLISIONRAMPVIEW_LAYER_ID } from 'components/layers/environment/HistoricalHighCollisionRampLayer';
import historicalHighCollisionRampSource from 'data/sources/environment/historicalHighCollisionRampSource';

import { HISTORICALMOOVEAI_LAYER_ID } from 'components/layers/demographics/HistoricalMooveAiLayer';
import historicalMooveAiSource from 'data/sources/demographics/historicalMooveAiSource';

import { HISTORICALBIKERVOLUME_LAYER_ID } from 'components/layers/demographics/HistoricalBikerVolumeLayer';
import historicalBikerVolumeSource from 'data/sources/demographics/historicalBikerVolumeSource';

import { HISTORICALPEDESTRIANVOLUME_LAYER_ID } from 'components/layers/demographics/HistoricalPedestrianVolumeLayer';
import historicalPedestrianVolumeSource from 'data/sources/demographics/historicalPedestrianVolumeSource';

import { DISTRICTBOUNDARIES_LAYER_ID } from 'components/layers/demographics/DistrictBoundariesLayer';
import districtBoundariesSource from 'data/sources/demographics/districtBoundariesSource';

import { SYSTEMICINTERSECTION_LAYER_ID } from 'components/layers/infrastructure/SystemicIntersectionLayer';
import systemicIntersectionSource from 'data/sources/infrastructure/systemicIntersectionSource';
 
import { SYSTEMICSEGMENT_LAYER_ID } from 'components/layers/infrastructure/SystemicSegmentLayer';
import systemicSegmentSource from 'data/sources/infrastructure/systemicSegmentSource';
 
import { SYSTEMICRAMP_LAYER_ID } from 'components/layers/infrastructure/SystemicRampLayer';
import systemicRampSource from 'data/sources/infrastructure/systemicRampSource';

import { TSN_HISTORICAL_INTERSECTION_LAYER_ID } from 'components/layers/infrastructure/TsnHistoricalIntersectionLayer';
import tsnHistoricalIntersectionSource from 'data/sources/infrastructure/tsnHistoricalIntersectionSource'

import { TSN_HISTORICAL_RAMP_LAYER_ID } from 'components/layers/infrastructure/TsnHistoricalRampLayer';
import tsnHistoricalRampSource from'data/sources/infrastructure/tsnHistoricalRampSource';

import { TSN_HISTORICAL_SEGMENT_LAYER_ID } from 'components/layers/infrastructure/TsnHistoricalSegmentLayer';
import tsnHistoricalSegmentSource from'data/sources/infrastructure/tsnHistoricalSegmentSource';

import { HARD_BRAKING_SOURCE_LAYER_ID } from 'components/layers/infrastructure/HardBrakingLayer';
import hardBrakingSource from 'data/sources/infrastructure/hardBrakingSource'

import {LANE_CLOSURE_SAFETY_SEGMENT_LAYER_ID} from 'components/layers/infrastructure/LaneClosureSafetySegmentLayer';
import laneClosureSafetySegmentSource from 'data/sources/infrastructure/laneClosureSafetySegmentSource';

import {LANE_CLOSURE_SAFETY_POINT_LAYER_ID} from 'components/layers/infrastructure/LaneClosureSafetyPointLayer';
import laneClosureSafetyPointSource from 'data/sources/infrastructure/laneClosureSafetyPointSource';

export const GENAI_DYNAMIC_LAYER_PREFIX = 'genaiDynamicLayer__';
export const GENAI_DYNAMIC_SOURCE_PREFIX = 'genaiDynamicSource__';

export const isGenaiDynamicLayerId = (id) =>
  typeof id === 'string' && id.startsWith(GENAI_DYNAMIC_LAYER_PREFIX);

export const isGenaiDynamicSourceId = (id) =>
  typeof id === 'string' && id.startsWith(GENAI_DYNAMIC_SOURCE_PREFIX);

const dynamicSuffixFromLayerId = (id) =>
  isGenaiDynamicLayerId(id) ? id.slice(GENAI_DYNAMIC_LAYER_PREFIX.length) : '';

const dynamicSuffixFromSourceId = (id) =>
  isGenaiDynamicSourceId(id) ? id.slice(GENAI_DYNAMIC_SOURCE_PREFIX.length) : '';

const layerSourceMapping = [
  {
    layer: CUSTOMSQL_LAYER_ID,
    source: customSqlSource.id,
    type: 'sql',
  },
  {
    layer: CUSTOMSQL_LAYER_ID,
    source: customSqlSource.id,
    type: 'wzs_incidents',
  },
  {
    layer: CUSTOMSQL_LAYER_ID,
    source: customSqlSource.id,
    type: 'rs_inventory_and_crashes',
  },
  {
    layer: CUSTOMSQL_SECONDARY_LAYER_ID,
    source: customSqlSecondarySource.id,
    type: 'sql-secondary',
  },
  {
    layer: CUSTOMSQL_SECONDARY_LAYER_ID,
    source: customSqlSecondarySource.id,
    type: 'wzs_lane_closures',
  },
  {
    layer: CUSTOMSQL_THIRD_LAYER_ID,
    source: customSqlThirdSource.id,
    type: 'sql-third',
  },
  {
    layer: CUSTOMSQL_FOURTH_LAYER_ID,
    source: customSqlFourthSource.id,
    type: 'sql-fourth',
  },
  {
    layer: CUSTOMSQL_FIFTH_LAYER_ID,
    source: customSqlFifthSource.id,
    type: 'sql-fifth',
  },
  {
    layer: TSN_HISTORICAL_INTERSECTION_LAYER_ID,
    source: tsnHistoricalIntersectionSource.id,
  },
  {
    layer: TSN_HISTORICAL_RAMP_LAYER_ID,
    source: tsnHistoricalRampSource.id,
  },
  {
    layer: TSN_HISTORICAL_SEGMENT_LAYER_ID,
    source: tsnHistoricalSegmentSource.id,
  },
  {
    layer: SYSTEMICINTERSECTION_LAYER_ID,
    source: systemicIntersectionSource.id,
  },
  {
    layer: SYSTEMICSEGMENT_LAYER_ID,
    source: systemicSegmentSource.id,
  },
  {
    layer: SYSTEMICRAMP_LAYER_ID,
    source: systemicRampSource.id,
  },
  {
    layer: POINTOFINTEREST_LAYER_ID,
    source: pointOfInterestSource.id,
  },
  {
    layer: CALEQUITYINDEX_LAYER_ID,
    source: calEquityIndexSource.id,
  },
  {
    layer: TRANSIT_ROUTE_LAYER_ID,
    source: transitRouteSource.id,
  },
  {
    layer: TRANSIT_STOP_LAYER_ID,
    source: transitStopSource.id,
  },
  {
    layer: HISTORICALHCCL_LAYER_ID,
    source: historicalHCCLSource.id,
  },
  {
    layer: HISTORICALHCCLINTERSECTION_LAYER_ID,
    source: historicalHCCLIntersectionSource.id,
  },
  {
    layer: HISTORICALHIGHCOLLISIONVIEW_LAYER_ID,
    source: historicalHighCollisionSource.id,
  },
  {
    layer: HISTORICALHIGHCOLLISIONRAMPVIEW_LAYER_ID,
    source: historicalHighCollisionRampSource.id,
  },
  {
    layer: HISTORICALMOOVEAI_LAYER_ID,
    source: historicalMooveAiSource.id,
  },
  {
    layer: HISTORICALBIKERVOLUME_LAYER_ID,
    source: historicalBikerVolumeSource.id,
  },
    {
    layer: HISTORICALPEDESTRIANVOLUME_LAYER_ID,
    source: historicalPedestrianVolumeSource.id,
  },
  {
    layer: DISTRICTBOUNDARIES_LAYER_ID,
    source: districtBoundariesSource.id,
  },
  {
    layer: HARD_BRAKING_SOURCE_LAYER_ID,
    source: hardBrakingSource.id,
  },
  {
    layer: LANE_CLOSURE_SAFETY_SEGMENT_LAYER_ID,
    source: laneClosureSafetySegmentSource.id,
  },
  {
    layer: LANE_CLOSURE_SAFETY_POINT_LAYER_ID,
    source: laneClosureSafetyPointSource.id,
  }
];

export const getLayerFromSource = (id) => {
  if (isGenaiDynamicSourceId(id)) {
    const suffix = dynamicSuffixFromSourceId(id);
    return `${GENAI_DYNAMIC_LAYER_PREFIX}${suffix}`;
  }
  let ans = '';
  layerSourceMapping.forEach((map) => {
    if (map.source === id) {
      ans = map.layer;
    }
  });
  return ans;
};

export const getSourceFromLayer = (id) => {
  if (isGenaiDynamicLayerId(id)) {
    const suffix = dynamicSuffixFromLayerId(id);
    return `${GENAI_DYNAMIC_SOURCE_PREFIX}${suffix}`;
  }
  let ans = '';
  layerSourceMapping.forEach((map) => {
    if (map.layer === id) {
      ans = map.source;
    }
  });
  return ans;
};

export const getSqlTypes = () => {
  return [
    'sql',
    'sql-secondary',
    'sql-third',
    'sql-fourth',
    'sql-fifth',
    'wzs_incidents',
    'wzs_lane_closures',
    'rs_inventory_and_crashes',
  ];
};

export const getLayerFromType = (id) => {
  let ans = '';
  layerSourceMapping.forEach((map) => {
    if (map?.type === id) {
      ans = map.layer;
    }
  });
  return ans;
};

export const getSourceFromType = (id) => {
  let ans = '';
  layerSourceMapping.forEach((map) => {
    if (map?.type === id) {
      ans = map.source;
    }
  });
  return ans;
};

export const getIdFromType = (type) => {
  if (type === 'sql' || type === 'wzs_incidents' || type === 'rs_inventory_and_crashes') return 0;
  if (type === 'sql-secondary' || type === 'wzs_lane_closures') return 1;
  if (type === 'sql-third') return 2;
  if (type === 'sql-fourth') return 3;
  if (type === 'sql-fifth') return 4;
  return -1;
};
